const InvoiceCancellationReasonEnum = {
  ALREADY_PAID: "ALREADY_PAID",
  PAID_AT_PRACTICE: "PAID_AT_PRACTICE",
  PATIENT_GOODWILL: "PATIENT_GOODWILL",
  PATIENT_ILLNESS: "PATIENT_ILLNESS",
  FORCE_MAJEURE: "FORCE_MAJEURE",
  OTHER_VALID_REASON: "OTHER_VALID_REASON"
};
const InvoiceStatus = {
  OPEN: "OPEN",
  PAID: "PAID",
  DRAFT: "DRAFT",
  CANCELLED: "CANCELLED"
};
const AppointmentCancellationEnum = {
  NO_SHOW: "NO_SHOW",
  CANCELED_SHORT_TERM: "CANCELED_SHORT_TERM"
};
export {
  AppointmentCancellationEnum,
  InvoiceCancellationReasonEnum,
  InvoiceStatus
};
